import React from 'react';
import { Helmet } from 'react-helmet';

const Page = ({ children, page }) => {
    const { meta: { title } } = page;
    return (
        <>
            <Helmet>
                <meta charSet='utf-8' />
                <title>{ title }</title>
            </Helmet>
            { children }
        </>
    );
};

export default Page;
